export default "https://cdn-static.gokick.com/assets/45a1ec4753cb63ac9804059da02cc099817f84d7/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";